exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "body.route-ProductProduct .images .gallery,body.route-ProductProductCommon .images .gallery{display:block}body.route-ProductProduct .images .gallery .wrapper,body.route-ProductProductCommon .images .gallery .wrapper{float:left;padding-top:20px}#footer .gallery{display:block}#footer .gallery .wrapper{float:left}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"id":"data-v-172e7c2c","scoped":false,"hasInlineConfig":false}!./node_modules/stylus-loader!./assets/vue/components/images/components/gallery.global.styl
// module id = 529
// module chunks = 0